import React from "react";
import { useLogout } from "../../services/LogoutProvider";
import "../css/UnauthorizedPopup.css";
import logoutIcon from "../../assets/images/logout_icon.svg";

const UnauthorizedPopup = () => {
  const { handleLogout } = useLogout();

  return (
    <div className="unauthorized-overlay">
      <div className="unauthorized-modal">
        <h2 className="unauthorized-title">Unauthorized Access</h2>
        <p className="unauthorized-message">
          You do not have the required permissions to access this application.
        </p>

        <button className="unauthorized-logout-button" onClick={handleLogout}>
          <img
            src={logoutIcon}
            alt="logout icon"
            className="unauthorized-logout-icon"
          />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedPopup;
